import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TextContext } from "@/utils/contexts/TextContext";
import ModalWrapperChildren from "@/views/components/Modal/ModalWrapperChildren";
import CloseIcon from '@/assets/icons/simpleTextAdvices/close_icon.svg';
import { formatTimeDate } from "@/utils/functions/formatTimeDate";

const ModalMetadataView = () => {
	const [ paramsArr, setParamsArr ] = useState([]);
	const { dict: { titletypes, letter: { metadata } } } = useSelector((state) => state.app);
	const { recipientsDict, categoriesDict } = useSelector(state => state.data);

	const {
		contextState: {
			viewMetadata,
			letterData,
		}, contextDispatch,
	} = useContext(TextContext);

	const handleOnClose = () => {
		contextDispatch({
			type: "setViewMetadata", payload: {
				viewMetadata: false,
			},
		});
	};

	const handleEditMetadata = async () => {
		await contextDispatch({
			type: "setViewMetadata", payload: {
				viewMetadata: false,
			},
		});
		await contextDispatch({
			type: "setEditLetterMetadata", payload: {
				editLetterMetadata: true,
			},
		});
	};

	useEffect(() => {
		if (letterData) {
			const {
				title,
				titleType,
				category,
				date,
				department: { name },
				recipient,
				author,
				owner: {
					displayName,
					email,
				},
				createdOn,
				modifiedOn,
			} = letterData;

			setParamsArr([
				{ id: 'metadataTitle', label: metadata?.title, value: title },
				{ id: 'metadataTitleType', label: metadata?.titleType, value: titletypes[titleType.replaceAll('-', '')]  },
				{ id: 'metadataCategory', label: metadata?.category, value: categoriesDict[category.code] },
				{ id: 'metadataWritingDate', label: metadata?.writingDate, value: formatTimeDate(date) },
				{ id: 'metadataAuthor', label: metadata?.writingAuthor, value: `${author?.forename || ''} ${author?.surname || ''}`},
				{ id: 'metadataDepartment', label: metadata?.department, value: name },
				{ id: 'metadataRecipient', label: metadata?.recipient, value: recipientsDict[recipient.code], hasDivider: true },
				{ id: 'metadataIntroductory', label: metadata?.introductory, value: `${displayName}, ${email}` },
				{ id: 'metadataAddedDate', label: metadata?.addedDate, value: formatTimeDate(createdOn) },
				{ id: 'metadataEditData', label: metadata?.editData, value: formatTimeDate(modifiedOn) },
			]);
		}
	}, [ letterData ]);
	return (
		<ModalWrapperChildren
			onClose={ handleOnClose }
			modalVisible={ viewMetadata }
			title={
				<div className="modal-metadata-view__header">
					{metadata.modalTitle}
					{letterData?.rights?.canEdit && (
						<button
							className="modal-metadata-view__edit-metadata-btn button__std"
							onClick={ handleEditMetadata }
						>
							{metadata.editMetadataBtn}
						</button>
					)}
					<button 
						onClick={ handleOnClose } 
						className="modal-metadata-view__close-modal-btn"
					>
						<img 
							src={ CloseIcon } 
							alt="close-icon" 
						/>
					</button>
				</div>
			}
		>
			<ul className="modal-metadata-view__list">
				{paramsArr.map(({ id, label, value, hasDivider }) => (
					<React.Fragment key={ id }>
						<li
							className="modal-metadata-view__list-item"
						>
							<span
								className="modal-metadata-view__list-item-text--label"
							>
								{label}:
							</span>
							<span className="modal-metadata-view__list-item-text--value">
								{(value && value.trim() !== '') ? value : metadata.none}
							</span>
						</li>
						{hasDivider && (
							<hr
								className="modal-metadata-view__list-item-divider"
							/>
						)}
					</React.Fragment>
				))}
			</ul>
		</ModalWrapperChildren>
	);
};

export default ModalMetadataView;
